module.exports = __webpack_public_path__ + "static/img/025 2.142b3d04.jpg";